<template>
  <Technology>
    <div class="techCase">
      <div class="techCase-search">
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="add"
          style="background: #623AA2;border: none;"
        >新增</el-button>
        <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
        <el-input
          placeholder="请输入内容"
          v-model="searchValue"
          class="input-with-select"
          @keyup.enter.native="search"
          clearable
          @clear="search"
        >
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <div class="selectType">
          <span>类型：</span>
          <el-select v-model="type" placeholder="请选择" clearable @change="selectType">
            <el-option label="全部" value></el-option>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div id="table">
        <!--动态绑定长宽-->
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          type="index"
          :header-cell-style="headerStyle"
          @selection-change="tabSelect"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column type="index" width="100" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center"></el-table-column>
          <el-table-column prop="content" label="内容" align="center"></el-table-column>
          <el-table-column prop="categoryFirst" label="类型" align="center" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.categoryFirst==1?'知产百科':scope.row.categoryFirst==2?'政策快讯':scope.row.categoryFirst==3?'工具指南':'产业链'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="是否发布" align="center" width="100">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.status == 1">已发布</el-tag>
              <el-tag type="info" v-else>未发布</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="hot" label="热门推荐" align="center" width="100">
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.hot == 2">已推荐</el-tag>
              <el-tag type="info" v-else>未推荐</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="发布平台" align="center">
            <template slot-scope="scope">
              {{ scope.row.isAchievement === 1 && scope.row.isMarket === 1 ? '双平台' : (scope.row.isMarket === 1 ? '大市场平台' : '成果交易平台') }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="380">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="preview(scope.row)"
                  v-if="scope.row.status==2"
                >确定发布</el-button>
                <el-button size="mini" type="warning" @click="preview(scope.row)" v-else>取消发布</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                <el-button
                  size="mini"
                  type="success"
                  @click="hot(scope.row)"
                  v-if="scope.row.hot==1"
                >热门推荐</el-button>
                <el-button size="mini" type="info" @click="hot(scope.row)" v-else>取消推荐</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="per_page"
        layout="total, prev, pager, next"
        :total="total"
        style="text-align:left;margin:20px 0"
      ></el-pagination>

      <el-dialog
	 
        :title="Title"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        @closed="resetFn"
      >
        <el-form
		 v-if="dialogFormVisible"
          :model="ruleForm"
          ref="ruleForm"
          label-width="75px"
          :rules="rules"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="标题" prop="title">
                <el-input v-model="ruleForm.title" clearable></el-input>
              </el-form-item>
              <el-form-item label="时间" prop="dateTime">
                <el-date-picker
                  v-model="ruleForm.dateTime"
                  :picker-options="pickerOptions"
                  type="datetime"
                  placeholder="选择日期"
                  style="text-align: left;width:100%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="类型" prop="categoryFirst">
                <el-select
                  v-model="ruleForm.categoryFirst"
                  placeholder="请选择"
                  clearable
                  style="width:100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="封面" prop="image">
                <el-upload
                  class="avatar-uploader"
                  :action="this.uploadURL"
                  name="file"
                  :show-file-list="false"
                  :on-success="handlePictureCardPreview"
                  :before-upload="beforeAvatarUpload"
                  :http-request="HouImgFile"
                >
                  <img v-if="ruleForm.image" :src="imgUrl+ruleForm.image" class="img_border" />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    :class="{is_border: !ruleForm.image}"
                  ></i>
                  <span class="upload_btn" v-if="!ruleForm.image">上传图片</span>
                  <span v-else class="upload_btn">更换图片</span>
                </el-upload>
                <span class="del_img" v-show="ruleForm.image">
                  <i class="el-icon-error" @click="deleteImg"></i>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="content" style="margin-top:5px;">
            <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
            <editor v-model="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl"></editor>
          </el-form-item>
          <el-form-item>
            <el-col :span="12">
              <el-form-item label="热门:" prop="hot" style="text-align:left">
                <el-switch
                  v-model="ruleForm.hot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  :active-value="2"
                  :inactive-value="1"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发布:" prop="status" style="text-align:left">
                <el-switch
                  v-model="ruleForm.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="2"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-form-item>
          
          <el-row>
              <el-form-item
                label="同步发布"
                prop="isMarket"
                style="text-align: left"
              >
                <el-select
                  v-model="isMarket"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="formmarket"
                >
                  <el-option label="双平台" :value="1"/>
                  <el-option label="大市场平台" :value="2"/>
                  <el-option label="成果交易平台" :value="3"/>
                </el-select>
              </el-form-item>
            </el-row>
          <el-form-item style="text-align:right">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="closeForm('ruleForm')">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </Technology>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import { DisabledDateFn } from "../../utils/tool";
import editor from "../../components/tinymce-editor/tinymce-editor";
import Technology from "./technology";
export default {
  components: {
    Technology,
    editor,
  },
  data() {
    return {
      resetForm: "",
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      isMarket:1,
      type: "",
      selected: "",
      searchValue: "",
      total: 10,
      per_page: 10,
      currentPage: 1,
      dialogFormVisible: false,
      Title: "",
      tableData: [],
      options: [
        {
          value: 1,
          label: "知产百科",
        },
        {
          value: 2,
          label: "政策快讯",
        },
        {
          value: 3,
          label: "工具指南",
        },
        {
          value: 4,
          label: "产业链",
        },
      ],
        is_submit : true,

      ruleForm: {
        title: "",
        dateTime: "",
        categoryFirst: "",
        content: "",
        status: 2,
        hot: 1,
        image: "",
        isMarket : 1,
        isAchievement : 1,
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        categoryFirst: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        dateTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getData("Science");
    this.resetFn(true);
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/science/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.currentPage = res.data.current_page;
          this.tableData.forEach((item) => {
            item.content = this.GetTarg(item.content);
             
          });
        }
      });
    },
    resetFn(flag = false) {
      if (flag) {
        this.resetForm = JSON.stringify(this.ruleForm);
      } else {
        this.ruleForm = JSON.parse(this.resetForm);
      }
    },
    //新增
    add() {
      this.isMarket = 1
      this.resetFn();
      this.ruleForm= {
        title: "",
        dateTime: "",
        categoryFirst: "",
        content: "",
        status: 2,
        hot: 1,
        image: "",
        isMarket : 1,
        isAchievement : 1,
      }
      this.is_submit = true
      this.dialogFormVisible = true;
    },
    formmarket(val) {
      if(val === 1){
        this.ruleForm.isMarket = 1
        this.ruleForm.isAchievement = 1
      }else if(val === 2){
        this.ruleForm.isMarket = 1
        this.ruleForm.isAchievement = 2
      }else{
        this.ruleForm.isMarket = 2
        this.ruleForm.isAchievement = 1
      }
    },
    //编辑
    handleEdit(val) {
      this.is_submit = true

      this.Title = "编辑";
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/science/get?id=` + val.id).then((res) => {
        if (res.code == 0) {
          this.ruleForm = res.data;
      this.isMarket =  this.ruleForm.isAchievement === 1 &&  this.ruleForm.isMarket === 1 ? 1 : ( this.ruleForm.isMarket === 1 ? 2 : 3)
          this.dialogFormVisible = true;
        }
      });
    },
    //提交
    submitForm(formName) {
      if(!this.is_submit) return;
      this.is_submit = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.dateTime = this.pbcFun.formatDate(
              new Date(this.ruleForm.dateTime),
              "yyyy-MM-dd hh:mm:ss"
          );
          let obj = this.ruleForm;

          if (!obj.id) {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/science/create`, obj).then((res) => {
              if (res.code == 0) {
              this.isMarket = 1
                this.$message.success("新建成功");
                this.getData("Science");
                this.dialogFormVisible = false;
                this.ResetSearch(['searchValue','type'])
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            }).catch(err => {
              this.is_submit = true
            });
          } else {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/science/update`, obj).then((res) => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.getData("Science");
                this.dialogFormVisible = false;
                this.ResetSearch(['searchValue','type'])

                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            }).catch(err => {
              this.is_submit = true;
            });
          }
        } else {
      this.is_submit = true

			// console.log("校验失败")
			// this.resetFn()
          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      //   this.$refs[formName].resetFields();
      // this.resetFn()
    },
    //发布
    preview(e) {
      let data = {};
      if (e.status == 1) {
        data.status = 2;
      } else if (e.status == 2) {
        data.status = 1;
      }
      data.id = e.id;
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/science/update`, data).then((res) => {
        if (res.code == 0) {
          if (data.status == 1) {
            this.$message.success("发布成功");
          } else {
            this.$message.success("已取消发布");
          }
          this.getData("Science");
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //热门
    hot(e) {
      let data = {};
      if (e.hot == 1) {
        data.hot = 2;
      } else if (e.hot == 2) {
        data.hot = 1;
      }
      data.id = e.id;
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/science/update`, data).then((res) => {
        if (res.code == 0) {
          if (data.hot == 1) {
            this.$message.success("已取消推荐");
          } else {
            this.$message.success("推荐成功");
          }
          this.getData("Science");
        } else {
          this.$message.error(res.status);
        }
      });
    },
    //搜索
    search() {
      this.getData(
        "Science?title=" + this.searchValue + "&categoryFirst=" + this.type
      );
    },
    selectType() {
      this.getData(
        "Science?title=" + this.searchValue + "&categoryFirst=" + this.type
      );
    },
    //删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/science/delete?id=` + row.id, "", "delete").then((res) => {
            if (res.code == 0) {
                this.ResetSearch(['searchValue','type'])

              this.searchValue = "";
              this.type = "";
              this.getData("Science");
              this.$message({
                type: "success",
                message: "删除成功",
              });

            } else {
              this.$message({
                message: "失败！",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.selected) {
        this.$confirm("确定删除文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/science/batchDelete?ids=` + this.selected, "", "delete")
              .then((response) => {
                if (response.code == 0) {
                this.ResetSearch(['searchValue','type'])

                  this.$message.success("删除成功！");
                  this.searchValue = "";
                  this.type = "";

                  this.getData("Science");
                }
              });
 
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的文件",
        });
      }
    },

    //翻页
    handleCurrentChange(val) {
      this.getData(
        "Science?title=" +
          this.searchValue +
          "&categoryFirst=" +
          this.type +
          "&page=" +
          val
      );
    },
    //选择行数
    tabSelect(sec) {
      let ids = "";
      for (let i of sec) {
        ids += i.id + ",";
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then((rst) => {
          this.http
            .post("/file/base64_upload", {
              image: rst.base64,
            })
            .then((res) => {
              this.ruleForm.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.ruleForm.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.ruleForm.image;
      img.onload = function () {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.ruleForm.image = "";
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.techCase {
  width: 100%;

  .techCase-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }
}

/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 178px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}

/deep/ .yh-quill-editor {
  .el-upload {
    display: none;
  }

  .ql-toolbar {
    text-align: left;
  }
}
</style>
